module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-wrap"
  }, [_c('div', {
    staticClass: "multi-item-title mt-40"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("자기소개서")]), _vm._v(" "), _c('div', {
    staticClass: "check-util"
  }, [_c('div', {
    staticClass: "check-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selfIntroUseYn),
      expression: "selfIntroUseYn"
    }],
    attrs: {
      "type": "checkbox",
      "id": "after",
      "true-value": "N",
      "false-value": "Y",
      "title": "나중에 작성할게요. 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.selfIntroUseYn) ? _vm._i(_vm.selfIntroUseYn, null) > -1 : _vm._q(_vm.selfIntroUseYn, "N")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selfIntroUseYn,
          $$el = $event.target,
          $$c = $$el.checked ? ("N") : ("Y");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selfIntroUseYn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selfIntroUseYn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selfIntroUseYn = $$c
        }
      }
    }
  }), _vm._m(0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-line-box btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "ico ico-refresh"
  }), _vm._v("\n        입력항목 초기화\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap mt-16"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("자기소개서 표")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "text-box-section resume-area"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.introduction.selfintro),
      expression: "introduction.selfintro"
    }],
    staticClass: "text-area-wrap",
    attrs: {
      "disabled": _vm.isDisabled,
      "title": "자기소개서 내용"
    },
    domProps: {
      "value": (_vm.introduction.selfintro)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.introduction, "selfintro", $event.target.value)
      }, _vm.handleSelfIntroInput]
    }
  })])])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "after"
    }
  }, [_c('span', [_vm._v("나중에 작성할게요.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "border-line-box self-introduction-notice mt-16"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("자기소개서 작성")]), _vm._v(" "), _c('ul', {
    staticClass: "list-type-dot mt-16"
  }, [_c('li', [_vm._v("\n        자기소개서의 정답은 없지만 보편적으로 자기소개서에는 다음과 같은 내용을 서술하여 작성합니다.\n        "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n          - 성장과정, 성격의 장단점, 지원동기, 직무관련 경험 및 역량, 입사 후 포부 및 목표\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tit mt-16"
  }, [_vm._v("추가 팁")]), _vm._v(" "), _c('ul', {
    staticClass: "list-type-dot mt-16"
  }, [_c('li', [_vm._v("\n        경험 기반으로 쓰기\n        "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n          단순히 \"저는 성실합니다\"가 아니라 왜 그렇게 말할 수 있는지 경험을 근거로 제시해야 설득력이 높습니다.\n        ")])]), _vm._v(" "), _c('li', [_vm._v("\n        회사/직무 맞춤형으로 작성\n        "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n          동일한 자기소개서를 여러 군데 제출하면 티가 납니다. 반드시 해당 기업/직무에 맞는 내용으로 수정하세요.\n        ")])]), _vm._v(" "), _c('li', [_vm._v("\n        분량은 제한을 지켜서\n        "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n          너무 짧거나 너무 길면 불리하게 작용할 수 있습니다.\n        ")])]), _vm._v(" "), _c('li', [_vm._v("\n        첫 글자를 시작하기 어려우면 다음 예시를 참고해보세요.\n        "), _c('div', {
    staticClass: "butotn-area"
  }, [_c('button', {
    staticClass: "btn btn-line-box btn-sm",
    attrs: {
      "type": "button",
      "onclick": "openModal(event)",
      "modal-id": "introductionEx1"
    }
  }, [_vm._v("예시 : 자기소개서 (경영사무직, 재취업용)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-line-box btn-sm",
    attrs: {
      "type": "button",
      "onclick": "openModal(event)",
      "modal-id": "introductionEx2"
    }
  }, [_vm._v("예시 : 자기소개서 (요양보호사, 중장년 남성, 신규 취업용)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-528861c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/resume/Introduction.vue
// module id = 1399
// module chunks = 6